<div class="teams-page">
  <app-workspace-hub-nav></app-workspace-hub-nav>
  <section class="teams-hero">
    <div>
      <div class="teams-kicker">Live operations</div>
      <h1>Monitor</h1>
      <p>Track monitored flow health and run outcomes across the enterprise workspace.</p>
    </div>
    <div class="teams-actions">
      <button type="button" class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow border-0" disabled>Last 7 Days</button>
      <button type="button" class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-slate-600 bg-white rounded-lg shadow hover:bg-slate-50 border-0 cursor-pointer transition-colors" (click)="downloadCsv()">Export Report</button>
    </div>
  </section>

  @if (contextState === 'loading') {
    <section class="teams-empty">Loading&hellip;</section>
  }

  @if (contextState === 'noStorage') {
    <section class="teams-empty teams-empty-warning">
      Your workspace is not yet provisioned with storage. Please contact support to complete setup.
    </section>
  }

  @if (contextState === 'noLicense') {
    <section class="teams-empty teams-empty-error">
      No FlowStudio for Teams licenses found.
    </section>
  }

  @if (contextState === 'ready') {
    <section class="teams-stats">
      <article class="teams-stat-card">
        <span class="teams-stat-label">Runs</span>
        <strong>{{ summary.totalRuns | number }}</strong>
        <span class="teams-stat-delta">Loaded for the current 7-day period</span>
      </article>
      <article class="teams-stat-card">
        <span class="teams-stat-label">Success rate</span>
        <strong>{{ (summary.successRate * 100) | number:'1.1-1' }}%</strong>
        <span class="teams-stat-delta">Succeeded of completed runs</span>
      </article>
      <article class="teams-stat-card">
        <span class="teams-stat-label">Failed runs</span>
        <strong>{{ summary.failedRuns | number }}</strong>
        <span class="teams-stat-delta">Failures in the current period</span>
      </article>
      <article class="teams-stat-card">
        <span class="teams-stat-label">Monitored flows</span>
        <strong>{{ summary.monitoredFlows | number }}</strong>
        <span class="teams-stat-delta">{{ summary.ruleCount | number }} configured monitoring rules</span>
      </article>
    </section>
    <section class="teams-table-card teams-table-card-main">
      <div class="teams-card-header">
        <div>
          <h2>Operational flow inventory</h2>
        </div>
        <div class="teams-toolbar">
          <div class="teams-search-wrap">
            <i class="ms-Icon ms-Icon--Search teams-search-icon"></i>
            <input
              type="search"
              class="teams-search-input"
              placeholder="Search flows…"
              [value]="gridSearch$.value"
              (input)="gridSearch$.next($any($event.target).value); gridSearchTerm = $any($event.target).value; currentPage = 0"
              />
          </div>
          <button
            type="button"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg shadow border-0 cursor-pointer transition-colors"
            [class]="flowFilter === 'monitored' ? 'text-blue-700 bg-blue-50 hover:bg-blue-100' : 'text-slate-600 bg-white hover:bg-slate-50'"
            (click)="setFlowFilter('monitored')"
            >
            Monitored
          </button>
          <button
            type="button"
            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium rounded-lg shadow border-0 cursor-pointer transition-colors"
            [class]="flowFilter === 'all' ? 'text-blue-700 bg-blue-50 hover:bg-blue-100' : 'text-slate-600 bg-white hover:bg-slate-50'"
            (click)="setFlowFilter('all')"
            >
            All
          </button>
        </div>
      </div>
      <app-teams-flows [Type]="flowFilter === 'monitored' ? 'monitor' : 'all'" [hideToolbar]="true" [externalSearch$]="gridSearch$"></app-teams-flows>
    </section>
    <div class="teams-bottom-cards">
      <section class="teams-side-card">
        <div class="teams-card-header teams-card-header-compact">
          <div>
            <div class="teams-card-kicker">Run history</div>
            <h2>Recent runs</h2>
          </div>
        </div>
        <div class="teams-log-list">
          @for (log of getSystemLogs(); track log) {
            <article class="teams-log-item">
              <div class="teams-log-time">{{ log.time }}</div>
              <div class="teams-log-body">
                <div class="teams-log-title" [class.is-success]="log.tone === 'success'" [class.is-warning]="log.tone === 'warning'">{{ log.title }}</div>
                <p>{{ log.detail }}</p>
              </div>
            </article>
          } @empty {
            <div class="teams-empty">No runs were returned for the current period.</div>
          }
        </div>
      </section>
      <section class="teams-side-card">
        <div class="teams-card-header teams-card-header-compact">
          <div>
            <div class="teams-card-kicker">Automation rules</div>
            <h2>Configured rules</h2>
          </div>
        </div>
        <app-schedule [rules$]="rules$"></app-schedule>
      </section>
    </div>
  }
</div>
